import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { PolicySetKey } from 'src/shared/constants';
import { UserPolicyEvalDto } from 'src/shared/services/api.service';
import { LocalStorageService } from 'src/shared/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CertRedirectorService {
  constructor(private readonly localStorageService: LocalStorageService) {}

  redirectUser(): string | UrlTree {
    const policySet = JSON.parse(this.localStorageService.get(PolicySetKey) ?? '{}') as UserPolicyEvalDto;

    if (policySet.canSelfAssignServiceItems) {
      return 'cert/services';
    } else if (policySet.canViewCaseIQ) {
      return 'cert/no-home';
    } else if (policySet.canViewCollectedPaymentsReport) {
      return 'cert/payments/collected-report';
    } else {
      return 'cert/no-home';
    }
  }
}
